var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7500_13797",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.339844,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7500_13797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4706 16.9024C13.9558 16.7774 12.4996 16.3775 11.1021 15.7028C9.70472 15.0281 8.43951 14.1229 7.30646 12.9874C6.17354 11.8517 5.27667 10.5899 4.61583 9.20195C3.955 7.81417 3.55514 6.36285 3.41625 4.84799C3.38847 4.55396 3.47382 4.29854 3.67229 4.08174C3.87062 3.86493 4.11861 3.75653 4.41625 3.75653H6.5925C6.84458 3.75653 7.06146 3.83216 7.24312 3.98341C7.42479 4.13452 7.55139 4.33188 7.62292 4.57549L8.05896 6.31903C8.09201 6.50486 8.0816 6.68646 8.02771 6.86382C7.97368 7.04118 7.88576 7.18542 7.76396 7.29653L5.83937 9.17007C6.1491 9.75118 6.49257 10.2982 6.86979 10.8111C7.24687 11.3239 7.66014 11.8035 8.10958 12.2499C8.55333 12.6935 9.03271 13.1044 9.54771 13.4826C10.0627 13.8608 10.6188 14.2048 11.216 14.5147L13.1902 12.5867C13.3067 12.4649 13.4403 12.3837 13.591 12.343C13.7416 12.3024 13.9099 12.296 14.0958 12.3238L15.764 12.6909C16.016 12.7604 16.2156 12.8885 16.3625 13.0755C16.5094 13.2624 16.5829 13.4847 16.5829 13.7422V15.9024C16.5829 16.2 16.471 16.448 16.2473 16.6463C16.0235 16.8448 15.7647 16.9301 15.4706 16.9024ZM5.35208 8.11236L6.92271 6.60591C6.94937 6.58452 6.96673 6.55514 6.97479 6.51778C6.98285 6.48042 6.98153 6.4457 6.97083 6.41361L6.60521 4.96799C6.59451 4.92535 6.57583 4.89334 6.54917 4.87195C6.5225 4.85056 6.48778 4.83986 6.445 4.83986H4.64542C4.61333 4.83986 4.5866 4.85056 4.56521 4.87195C4.54396 4.89334 4.53333 4.92007 4.53333 4.95216C4.57597 5.47993 4.66917 6.00632 4.81292 6.53132C4.95653 7.05646 5.13625 7.58348 5.35208 8.11236ZM12.3104 15.0226C12.8086 15.2417 13.3295 15.4082 13.8731 15.5219C14.4169 15.6356 14.9216 15.7191 15.3873 15.7726C15.4194 15.7726 15.4461 15.7619 15.4675 15.7405C15.4889 15.7191 15.4996 15.6924 15.4996 15.6603V13.8655C15.4996 13.8227 15.4889 13.788 15.4675 13.7613C15.4461 13.7347 15.4141 13.716 15.3715 13.7053L14.0173 13.4119C13.9852 13.4013 13.9572 13.3999 13.9331 13.408C13.9091 13.416 13.8837 13.4334 13.8569 13.4601L12.3104 15.0226Z",
    fill: "#495057"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.aa83404462395b1ae6e0f76b4dad2bbf.svg";
export { ForwardRef as ReactComponent };